import useGasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeter'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { Spinner } from 'baseui/spinner'
import MeterCompleteInformation from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterCompleteInformation'

const MeterInformation = ({ type }) => {
  const { t, pceEligibilityPending, pceEligibilityLoading, pceEligibilityData, meterConsent, css } = useGasMeter({
    type,
  })

  if (!meterConsent) {
    return null
  }

  return (
    <>
      <SDNotification
        type={'warning'}
        hidden={!pceEligibilityPending}
        primaryText={t('subscriptionForm:pce_module.meter_authorization.pending')}
      />
      {pceEligibilityLoading && (
        <>
          <div
            className={css({
              alignItems: 'center',
              display: 'flex',
            })}
          >
            <Spinner size='2rem' />
            <p
              className={css({
                marginLeft: '0.625rem',
              })}
            >
              {t('subscriptionForm:pce_module.eligibility_loading_info')}
            </p>
          </div>
          <p className={css({ margin: '0.625rem 0 0 0.625rem', fontStyle: 'italic', fontSize: '0.75rem' })}>
            {t('subscriptionForm:pce_module.meter_authorization.warning_no_response')}
          </p>
        </>
      )}

      <MeterCompleteInformation currentValue={pceEligibilityData} type={type} />
    </>
  )
}

export default MeterInformation
